module.exports = __webpack_public_path__ + "img/text.6dfeff17.png";